export { default } from './SocialLoginButton';



// WEBPACK FOOTER //
// ./src/components/auth/SocialLoginButton/index.js